module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// AMC_Banner Widget

(function (fox, $) {
	
	fox.registerWidget('AMC_Banner', {

		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				'embed.location': 'under'
			});

			this.callParent('configure', arguments);
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/banner.js
// module id = 813
// module chunks = 4